(function() { module.exports = window["wp"]["editor"]; }());